import clienteAxios from "../config/axios";

export async function getAllCuentasCorrientes () {
    return clienteAxios.get(`/all/cuentasCorrientes`);
}

export async function getCuentasCorrientesByNroCta (nroCta) {
    return clienteAxios.get(`/cuentasCorrientes/nroCta/${nroCta}`);
}

export async function deleteAndGetCuentasCorrientesByNroCtaFromSoftland (nroCta) {
    return clienteAxios.get(`/deleteAndGet/cuentasCorrientesByNroCtaFromSoftland/nroCta/${nroCta}`);
}
